import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "filexls"
const FilexlsIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M5.375 19.125H3.5a.627.627 0 0 1-.625-.625v-15c0-.344.281-.625.625-.625h6.25V6c0 .691.559 1.25 1.25 1.25h3.125v5.625H16v-5.84a2.5 2.5 0 0 0-.73-1.77L11.734 1.73A2.5 2.5 0 0 0 9.964 1H3.5A2.5 2.5 0 0 0 1 3.5v15C1 19.879 2.121 21 3.5 21h1.875zM19.08 20.95q.516.202 1.22.202.74 0 1.273-.23.531-.234.812-.656.285-.426.285-1v-.004q0-.457-.187-.778a1.4 1.4 0 0 0-.57-.527q-.387-.207-.989-.324l-.582-.113q-.456-.087-.664-.227a.45.45 0 0 1-.203-.387v-.004q0-.168.098-.293a.65.65 0 0 1 .285-.199q.183-.075.437-.074.262 0 .461.074a.8.8 0 0 1 .317.207q.12.129.152.309l.008.043h1.328l-.004-.047a1.77 1.77 0 0 0-.312-.883 1.8 1.8 0 0 0-.762-.605q-.489-.223-1.195-.223-.65 0-1.153.226-.504.223-.793.633-.288.406-.293.957v.004q0 .66.406 1.078.411.419 1.301.594l.582.113q.496.098.703.227a.41.41 0 0 1 .207.367v.004a.48.48 0 0 1-.117.316.73.73 0 0 1-.32.22q-.207.077-.488.077-.285 0-.504-.078a.9.9 0 0 1-.348-.21.53.53 0 0 1-.148-.31l-.004-.034h-1.371l.003.07q.032.524.32.902.294.375.81.582M13.519 21v-5.637h1.433v4.485h2.395V21z" />
      <path d="M9.059 18.17 7.339 21h1.528l1.086-1.828h.035L11.086 21h1.61l-1.778-2.819v-.02l1.793-2.798h-1.594l-1.024 1.907h-.042L9.02 15.363H7.34l1.719 2.782z" />
    </svg>
  )
}
export default FilexlsIcon
